module.exports = __webpack_public_path__ + "Roboto-Thin.790ebf41d0214f5eda4e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Thin.woff2
// module id = 131
// module chunks = 17